
<script>
import axios from 'axios';
import store from '@/store/index.js'
import router from '@/router/index.js'

// Function to Get the server return content Language
function getLanguage(response){
    try{
        let data = response['headers']['content-language']
        if(data.match(/zh-hk.*/)){
            // Is Chinese
            return "zh-hk"
        }else{
            // Others (en)
            return data
        }
    }catch(e){
        // default
        return "zh-hk"
    }
}

// Return Translated Title
function getSwalTitle(data, mode){
    let returnData = ""
    if(data === "zh-hk"){
        switch (mode){
            case "error":
                returnData = "錯誤"
                break
            case "warning":
                returnData = "警告"
                break
            case "info":
                returnData = "信息"
                break
            case "success":
                returnData = "成功"
                break
            default:
                returnData = "提示"
                break
        }
    }else{
        // English
        switch (mode) {
            case "error":
                returnData = "Error"
                break
            case "warning":
                returnData = "Warning"
                break
            case "info":
                returnData = "Information"
                break
            case "success":
                returnData = "Success"
                break
            default:
                returnData = "Reminder"
                break
        }
    }
    return returnData
}


// Return Error Details
function getErrorDetails(data){
    if(Object.keys(data).length > 1){
        return "<pre style='text-align: left;font-size: 10px'>" + JSON.stringify(data, null, 4) + "</pre>"
    }
    let keyName = Object.keys(data)[0]
    // console.log(typeof data[keyName])
    if(typeof data[keyName] == "object") {
        return "<h5>" + data[keyName][0] + "</h5>"
    }else if(typeof data[keyName] == "string") {
        return "<h5>" + data[keyName] + "</h5>"
    }else{
        return "<h5>" + data[keyName] + "</h5>"
    }
}


// init it to get the Language
store.commit('initializeStore')

const http = axios.create({
    baseURL: store.state.serverIp,
    headers: {
        'Content-Type': 'application/json',
    }
});

// http.post('api/auth/', {
//     "username": "client",
//     "password": "P@ssw0rdF0rClient"
// })
//     .then(response => {
//         console.log(response.data.token)
//         store.commit("setServerToken")
//         http.defaults.headers.common['Authorization'] = "Token " + response.data.token;
//         http.defaults.headers.common['Accept-Language'] = store.state.language;
//
//         // Check if user still login, set API headers here
//         // ** put in store will error cuz that time Axios is not created
//         if(store.state.isAuthenticated === true){
//             http.defaults.headers.common['GL-User-ID'] = store.state.userServerID;
//             http.defaults.headers.common['GL-User-Online-ID'] = store.state.userOnlinePK;
//             http.defaults.headers.common['GL-Page-ID'] = "1";
//             http.defaults.headers.common['GL-Action-ID'] = "1";
//             console.log("User Data Added to Headers")
//         }
//     })

http.interceptors.response.use(
    response => {
        response = { ...response };

        let nowLang = getLanguage(response)
        if(response.data.status === 99){
            Swal.fire({
                title: getSwalTitle(nowLang, "error"),
                html: "<h6>Cannot Connect to GL server | 無法連線高力堡伺服器</h6><hr><code>"+ response.data.details +"</code>",
                icon: "error",
            })
            return Promise.reject(response);
        }else if(response.data.status === 1){
            // Not Logged in
            store.commit('setUserLogout')
            router.push("/login")
            return response;
        }else if(response.data.status === 2){
            // No Permission
            // router.back()
            router.push('/error/no-permission')
            Swal.fire({
                title: getSwalTitle(nowLang, "error"),
                html: "<h6>You Have No Permission | 你沒有權限</h6>",
                icon: "error",
            })
            store.commit('setIsBlackLayout', false)
            store.commit('setIsTopLoading', false)
            // return Promise.reject(response);
            return response;
        }else if(response.data.status === 100){
            console.log("Missing Headers | 缺少 HTML Header")
            // Missing Headers
            // Swal.fire({
            //     title: getSwalTitle(nowLang, "error"),
            //     html: "<h6>Missing Headers | 缺少 HTML Header</h6>",
            //     icon: "error",
            // })
            return response;
            // return Promise.reject(response);
        }else{
            return response;
        }
    },
    function(error) {
        // console.log(error.response['headers']['content-language'])
        let nowLang = getLanguage(error.response)

        // Request failed, JSON String has been Beautified
        if(error.response.status !== 200){
            Swal.fire({
                title: getSwalTitle(nowLang, "error"),
                html: "<h3>" +
                            error.response.status + " " + error.response.statusText +
                      "</h3> " +
                      "<hr> " +
                      getErrorDetails(error.response.data)
                ,
                icon: "error",
            })
        }
        return Promise.reject(error);
    }
);

export default http;

</script>
